module.exports = __webpack_public_path__ + "static/img/happy-doc.90f1663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/IndraDhanush/IndraDhanush-pics/happy-doc.jpg
// module id = u9fR
// module chunks = 0